import { useTranslationApp } from "../../lib/i18next";
import Chip from "@mui/material/Chip";
import { OPTIONAL } from "../../i18n/keysTranslations";
import {
  CHIP_SEARCH_COMPONENT_COLOR,
  INPUT_COLOR_BORDER,
} from "../../utils/colors";

const ChipOptional = ({ size = "medium" }) => {
  const { t } = useTranslationApp();
  return (
    <Chip
      label={t(OPTIONAL)}
      size={size}
      sx={{
        backgroundColor: CHIP_SEARCH_COMPONENT_COLOR,
        border: `1px solid ${INPUT_COLOR_BORDER}`,
      }}
    />
  );
};

export default ChipOptional;
